import SplitText from 'gsap/SplitText';
import gsap from 'gsap';

// Ignore split warnings for SplitText
export function enableIgnoreSplitWarnings() {
    const originalWarn = console.warn;
    console.warn = function (...args) {
        if (
            typeof args[0] === 'string' &&
            args[0].includes('SplitText called before fonts loaded')
        ) {
            // Suppress it
            return;
        }
        originalWarn.apply(console, args);
    };
}

/**
* Splits title and returns chars
*
* @param {HTMLElement} [titleElement] - The title element
* @returns {HTMLElement[]} Char array
*/
export function splitTitleToChars(titleElement) {
    const splitTitleChars1 = SplitText.create(titleElement, {
        type: 'words, chars',
        charsClass: 'gsap-of'
    });
    const splitTitleChars2 = SplitText.create(splitTitleChars1.chars, {
        type: 'chars'
    });

    return splitTitleChars2.chars;
}


/**
* Creates a title animation
*
* @param {Timeline} tl - Timeline
* @param {Object} [options={}] - The options object.
* @param {HTMLElement[]} [options.chars] - Title chars array
* @param {string} [options.offset=">0"] - Animation offset (default: `">0"`)
* @param {number} [options.duration=0.38] - Animation duration (default: `0.38`)
* @param {number} [options.stagger=0.013] - Animation stagger (default: `0.013`)
* @returns {Timeline} Timeline instance
*/
export function animTitleHelper(tl, options) {
    const defaultOptions = {
        offset: '>0',
        duration: 0.35,
        stagger: .018
    };
    options = {...defaultOptions, ...options};

    const titleChars = options.chars;

    gsap.set(titleChars, {
        xPercent: 185
    });

    tl.fromTo(titleChars, {
        xPercent: 185
    }, {
        duration: options.duration,
        ease: 'power2.out',
        xPercent: 0,
        stagger: options.stagger,
    }, options.offset);

    return tl;
}



/**
* Splits text and returns chars
*
* @param {HTMLElement} [titleElement] - The title element
* @returns {HTMLElement[]} Char array
*/
export function splitTextToWords(textElements) {
    const splitTextWords = SplitText.create(textElements, {type: 'words'});

    return splitTextWords.words;
}

/**
* Creates a text animation
*
* @param {Timeline} tl - Timeline
* @param {Object} [options={}] - The options object.
* @param {HTMLElement[]} [options.words] - Title chars array
* @param {string} [options.offset=">0"] - Animation offset (default: `">0"`)
* @param {number} [options.duration=0.6] - Animation duration (default: `0.6`)
* @param {number} [options.stagger=0.05] - Animation stagger (default: `0.05`)
* @returns {Timeline} Timeline instance
*/
export function animWordsHelper(tl, options) {
    const defaultOptions = {
        offset: '>0',
        duration: 0.38,
        stagger: 0.05,
    };
    options = {...defaultOptions, ...options};

    const textWords = options.words;

    gsap.set(textWords, {
        opacity: 0,
        y: 20,
    });

    tl.fromTo(textWords, {
        opacity: 0,
        y: 20,
    }, {
        opacity: 1,
        y: 0,
        rotate: 0,
        stagger: options.stagger,
        duration: options.duration,
        ease: 'power2.out',
        immediateRender: false,
        duration: .6
    }, options.offset);

    return tl;
}

